import BasicTemplate from '../templates/BasicTemplate'

export default function Error() {
    return (
        <BasicTemplate>
            <h1>Error Page</h1>
        </BasicTemplate>
    )
}
